<!-- Start Breadcrumb
============================================= -->
<div class="breadcrumb-area bg-cover shadow theme-hard text-center text-light"
  style="background-image: url(assets/img/banner/8.jpg);">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 offset-lg-2">
        <h1>Contact Us</h1>
        <ul class="breadcrumb">
          <li><a routerLink="/"><i class="fas fa-home"></i> Home</a></li>
          <li>Contact</li>
        </ul>
      </div>
    </div>
  </div>
</div>
<!-- End Breadcrumb -->
<!-- Start Contact Us
============================================= -->
<div class="contact-style-one-area overflow-hidden default-padding">

  <div class="contact-shape">
    <img src="assets/img/shape/37.png" alt="Image Not Found">
  </div>

  <div class="container">
    <div class="row align-center">

      <div class="contact-stye-one col-lg-5 mb-md-50 mb-xs-20">

        <div class="contact-style-one-info">
          <h2 class="split-text">Contact Information</h2>
          <p class="wow fadeInUp" data-wow-delay="100ms">
            Connect directly with our solutions and engineering team. Whether you need a live demo of Norbix Enterprise, university campus automation, or bespoke cloud software development, we are ready to assist.
          </p>
          <ul>
            <li class="wow fadeInUp">
              <div class="icon">
                <i class="fas fa-phone-alt"></i>
              </div>
              <div class="content">
                <h5 class="title">Hotline</h5>
                <a href="tel:+919281441225">+91 92814 41225</a>
              </div>
            </li>
            <li class="wow fadeInUp" data-wow-delay="300ms">
              <div class="icon">
                <i class="fas fa-map-marker-alt"></i>
              </div>
              <div class="info">
                <h5 class="title">Our Location</h5>
                <p>
                  Registered Office: #5-8-670, Srinivasa Nagar, <br />Tadigadapa, Vijayawada, Krishna (Dist),
                  <br />Andhra Pradesh, India. Pincode: 521137
                </p>
              </div>
            </li>
            <li class="wow fadeInUp" data-wow-delay="500ms">
              <div class="icon">
                <i class="fas fa-envelope-open-text"></i>
              </div>
              <div class="info">
                <h5 class="title">Official Email</h5>
                <a href="mailto:info@novarix.tech">info@novarix.tech</a>
                <br />
                <a href="mailto:novarixtech@gmail.com">novarixtech@gmail.com</a>
              </div>
            </li>
            <li class="wow fadeInUp" data-wow-delay="700ms">
              <div class="icon">
                <i class="fas fa-clock"></i>
              </div>
              <div class="info">
                <h5 class="title">Operating Hours</h5>
                <p>Monday – Saturday: 9:30 AM – 6:30 PM IST</p>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="contact-stye-one col-lg-7 pl-60 pl-md-15 pl-xs-15">
        <div class="contact-form-style-one">
          <h5 class="sub-title">Have Questions or Need a Demo?</h5>
          <h2 class="title">Send Us a Message</h2>
          <form action="assets/mail/contact.php" method="POST" class="contact-form contact-form">
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group">
                  <input class="form-control" id="name" name="name" placeholder="Full Name *" type="text" required>
                  <span class="alert-error"></span>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <input class="form-control" id="email" name="email" placeholder="Business Email *" type="email" required>
                  <span class="alert-error"></span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group">
                  <input class="form-control" id="phone" name="phone" placeholder="Phone Number" type="text">
                  <span class="alert-error"></span>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <select class="form-control" id="interest" name="interest" style="height: 52px; color: #495057;">
                    <option value="" disabled selected>Area of Interest / Service</option>
                    <option value="norbix-enterprise">Norbix Enterprise Suite Demo</option>
                    <option value="campus-automation">University / Campus Automation</option>
                    <option value="novafleet">NovaFLEET & Logistics Tracking</option>
                    <option value="novahrm">NovaHRM & Payroll Management</option>
                    <option value="custom-software">Custom Cloud & Software Engineering</option>
                    <option value="other">General Partnership Inquiry</option>
                  </select>
                  <span class="alert-error"></span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group comments">
                  <textarea class="form-control" id="comments" name="comments"
                    placeholder="Tell us about your project requirements or institutional workflow goals *"></textarea>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <button type="submit" name="submit" id="submit">
                  <i class="fa fa-paper-plane"></i> Send Message
                </button>
                <div class="mt-3 pt-1 text-muted d-flex align-items-center gap-3 flex-wrap" style="font-size: 13px;">
                  <span><i class="fas fa-shield-alt text-primary me-1"></i> NDA Protected</span>
                  <span><i class="fas fa-bolt text-primary me-1"></i> 24-Hour Response Guarantee</span>
                  <span><i class="fas fa-user-check text-primary me-1"></i> Direct Architect Consultation</span>
                </div>
              </div>
            </div>
            <!-- Alert Message -->
            <div class="col-lg-12 alert-notification">
              <div id="message" class="alert-msg"></div>
            </div>
          </form>
        </div>
      </div>



    </div>
  </div>
</div>
<!-- End Contact -->
<!-- Start Map
============================================= -->
<div class="maps-area bg-gray overflow-hidden">
  <div class="google-maps">
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3825.892334201768!2d80.6905073!3d16.4809885!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35fb0006fed653%3A0xa094cf093b16dd6a!2sNOVARIX%20TECH!5e0!3m2!1sen!2sin!4v1756608368664!5m2!1sen!2sin"></iframe>

  </div>
</div>
<!-- End Map -->